import { render, staticRenderFns } from "./NavigationDrawerFilters.vue?vue&type=template&id=54bf7b30&scoped=true"
import script from "./NavigationDrawerFilters.vue?vue&type=script&lang=ts"
export * from "./NavigationDrawerFilters.vue?vue&type=script&lang=ts"
import style0 from "./NavigationDrawerFilters.vue?vue&type=style&index=0&id=54bf7b30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bf7b30",
  null
  
)

export default component.exports